import { TextBadge } from 'ui/components'
import { DocumentStatuses } from '~bank-documents/types/enums/DocumentStatuses'

export const DocumentPeriodStatus = (props: { name: string }) => {
  const { name } = props

  switch (name) {
    case DocumentStatuses.APPROVED:
    case DocumentStatuses.ACCEPTED:
      return (
        <TextBadge color="positive" data-qa="document-period-status">
          {name}
        </TextBadge>
      )
    case DocumentStatuses.REJECTED:
    case DocumentStatuses.INCOMPLETE:
      return (
        <TextBadge color="error" data-qa="document-period-status">
          {name}
        </TextBadge>
      )
  }

  return (
    <TextBadge color="default" data-qa="document-period-status">
      {name}
    </TextBadge>
  )
}
